export default "__VITE_ASSET__JBelRMg4__"